import {InjectionToken,LOCALE_ID,PLATFORM_ID,inject,isDevMode} from '@angular/core';
import {isPlatformBrowser,isPlatformServer} from '@angular/common';
import {FirebaseApp,getApp,getApps,initializeApp} from 'firebase/app';
import {Auth,getAuth} from 'firebase/auth';
import {Analytics,getAnalytics} from 'firebase/analytics';
import {AppCheck,CustomProvider,ReCaptchaV3Provider,initializeAppCheck} from 'firebase/app-check';
import {environment} from '../../../environments/environment';

export const FIREBASE_APP=new InjectionToken<FirebaseApp>('firebase.app',{
	providedIn:'root',
	factory:()=>getApps().length ? getApp() : initializeApp(environment.firebase)
});

export const FIREBASE_AUTH=new InjectionToken<Auth>('firebase.auth',{
	providedIn:'root',
	factory:()=>{
		if(isPlatformServer(inject(PLATFORM_ID))){
			return {languageCode:null} as unknown as Auth;
		}
		const auth=getAuth(inject(FIREBASE_APP));
		auth.languageCode=inject(LOCALE_ID);
		return auth;
	}
});

export const FIREBASE_ANALYTICS=new InjectionToken<()=>Analytics|null>('firebase.analytics',{
	providedIn:'root',
	factory:()=>{
		const isBrowser=isPlatformBrowser(inject(PLATFORM_ID));
		const app=isBrowser ? inject(FIREBASE_APP) : null;
		let instance:Analytics|null=null;
		return ():Analytics|null=>{
			if(!isBrowser||!app||!environment.firebase.measurementId) return null;
			instance??=getAnalytics(app);
			return instance;
		};
	}
});

export const FIREBASE_APP_CHECK=new InjectionToken<AppCheck>('firebase.appCheck',{
	providedIn:'root',
	factory:()=>{
		const app=inject(FIREBASE_APP);
		if(isPlatformServer(inject(PLATFORM_ID))){
			const provider:CustomProvider=new CustomProvider({
				getToken:()=>Promise.reject(new Error('App Check is not available during server-side rendering'))
			});
			return initializeAppCheck(app,{provider,isTokenAutoRefreshEnabled:false});
		}
		if(isDevMode()){
			(globalThis as {FIREBASE_APPCHECK_DEBUG_TOKEN?:boolean|string}).FIREBASE_APPCHECK_DEBUG_TOKEN??=true;
		}
		const provider:ReCaptchaV3Provider=new ReCaptchaV3Provider(environment.google.recaptcha3SiteKey);
		return initializeAppCheck(app,{provider,isTokenAutoRefreshEnabled:true});
	}
});
